import { useState } from 'react';
import { Box, FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import { FormLabel } from '@/components/v4';
import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { typeOptions } from '../constants';

/**
 * Service Category Type field — Standard/Location dropdown using the shared
 * DropDown formik field (standard 30px height, matching the Wholesaler (GA)
 * form's DefaultPlan.jsx usage), with the info tooltip shown on hover.
 */
const ServiceCategoryTypeField = ({
    errors,
    touched,
    darkMode,
    setFieldValue,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleSelectChange = (item) => {
        setFieldValue('type', item?.id ?? '');
    };

    return (
        <FormControl
            isRequired
            isInvalid={!!errors.type && touched.type}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>Type</FormLabel>
                <Box flex={1}>
                    <Field
                        component={DropDown}
                        name="type"
                        data={typeOptions}
                        shownValue="name"
                        placeholder="Select type"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="'Standard' indicates the service's filter option, while 'Location' specifies its grouping."
                        ariaLabel="service-category-type-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.type}</FieldError>
        </FormControl>
    );
};

export default ServiceCategoryTypeField;
